import React, { startTransition, useEffect, useState } from 'react'
import clsx from 'clsx'

import { Image } from '@/components/atoms/Image/Image'
import { CustomLink } from '@/components/atoms/CustomLink/CustomLink'
// import { LanguageSwitch } from '@/components/organisms/Header/LanguageSwitch/LanguageSwitch'
import { translateContent } from '@/helpers/translateContent'
import { ReactComponent as MenuIcon } from '@/assets/icons/menu.svg'
import DesktopNavigation from './DesktopNavigation'
import MobileNavigation from './MobileNavigation'
import LogIn from './LogIn'

import { Props } from './types'
// import { SearchModal } from './SearchModal'

export function Header({
  buttons,
  logo,
  navigation,
  currentLang,
  simple,
  showLogoOnly
  // alternates,
  // search_placeholder,
  // search_no_results,
  // suggestions_title,
  // blog_results_title,
  // help_results_title,
  // website_results_title
}: Props) {
  const [isOpen, setOpen] = useState(false)
  // const [searchOpen, toggleSearch] = useState(false)
  const logoLink = currentLang?.code === process.env.GATSBY_DEFAULT_LANGUAGE ? '/' : `/${currentLang?.code}`
  // const searchResultsTitles = {
  //   website: website_results_title,
  //   help: help_results_title,
  //   blog: blog_results_title
  // }
  useEffect(() => {
    const { body } = document
    return () => {
      body.classList.remove('menu-open')
    }
  }, [])

  const handleOpen = () => {
    startTransition(() => {
      const { body } = document

      setOpen((val) => !val)
      body.classList.toggle('menu-open')
    })
  }

  // const toggleSearchBar = () => {
  //   toggleSearch(!searchOpen)
  // }

  const menuAriaLabel = translateContent(currentLang?.code, 'menu')

  return (
    <header
      className="relative z-20 max-w-screen-desktop mx-auto px-24 laptop:px-90 py-24
      flex justify-center items-center"
    >
      <div className="relative flex justify-between items-center md:justify-start md:space-x-40 w-full">
        <CustomLink
          is_external={false}
          link_url={{
            cached_url: logoLink,
            id: 'logo-link',
            url: '',
            fieldtype: 'multilink',
            linktype: ''
          }}
          new_tab={false}
          className="flex-shrink-0"
        >
          <Image
            fixed
            data={logo}
            options={{ width: 103, loading: 'eager' }}
            width={103}
            height={20}
            className="w-131"
            loading="eager"
          />
        </CustomLink>
        {!showLogoOnly && (
          <>
            <div className="flex netbook:hidden">
              <MobileNavigation
                links={navigation}
                logo={logo}
                // languages={languages}
                // currentLang={currentLang}
                isOpen={isOpen}
                handleOpen={handleOpen}
                simple={simple}
                buttons={buttons}
              />
            </div>

            <div className="flex justify-end w-full netbook:items-center">
              {!simple && <DesktopNavigation links={navigation} simple={simple} />}
              {/* <SearchModal */}
              {/*   isOpen={searchOpen} */}
              {/*   onClick={toggleSearchBar} */}
              {/*   placeholder={search_placeholder} */}
              {/*   noResults={search_no_results} */}
              {/*   sectionTitle={suggestions_title} */}
              {/*   searchResultTitles={searchResultsTitles} */}
              {/*   language={currentLang} */}
              {/*   searchRedirect="search/" */}
              {/*   suggestionIndexName={process.env.GATSBY_ALGOLIA_INDEX_PAGES_PROD || ''} */}
              {/* /> */}
            </div>
            <div className="hidden netbook:flex netbook:items-center">
              <LogIn buttons={buttons} />
              {/* <LanguageSwitch currentLang={currentLang} languages={languages} alternates={alternates} /> */}
            </div>
            <button
              onClick={handleOpen}
              type="button"
              className={clsx(!simple && 'ml-auto', 'netbook:hidden [&>svg]:size-24')}
              aria-label={menuAriaLabel}
            >
              <MenuIcon />
            </button>
          </>
        )}
      </div>
    </header>
  )
}
